import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';

let WholePortionSievingMassesSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const isWashed = useSelector(pipe(createWorksheetSelector!(`Washing.IsWashed`), valueOrDefault(false)));
  return (
    <ListFieldSection>
      <Field input={<TextOutput />} name="Masses.DryMass" label="Specimen Total Dry Mass" />
      <Field
        input={<TextOutput />}
        label="Sieve Portion Washed Material Dry Mass"
        name="Washing.WashedDryMass"
        visible={isWashed}
      />
    </ListFieldSection>
  );
};
WholePortionSievingMassesSection = withInjectedProps(WholePortionSievingMassesSection);

export { WholePortionSievingMassesSection };
export default WholePortionSievingMassesSection;
